<div class="view-account" *ngIf="!editForm && user">
  <div class="row">
    <label class="col-4" i18n="The prefix inside the personal details block for the first name of the user@@firstNamePersonalDetailPrefix">First Name:</label>
    <div class="col-8 col-value">{{ user.paramValues.firstName }}</div>
  </div>
  <div class="row">
    <label class="col-4" i18n="The prefix inside the personal details block for the last name of the user@@lastNamePersonalDetailPrefix">Last Name:</label>
    <div class="col-8 col-value">{{ user.paramValues.lastName }}</div>
  </div>
  <div class="row">
    <label class="col-4" i18n="The prefix inside the personal details block for the company of the user@@companyNamePersonalDetailPrefix">Company:</label>
    <div class="col-8 col-value">{{ user.paramValues.company }}</div>
  </div>
  <div class="row">
    <label class="col-4" i18n="The prefix inside the personal details block for the phone of the user@@phonePersonalDetailPrefix">Phone:</label>
    <div class="col-8 col-value">{{ user.paramValues.phone }}</div>
  </div>
  <div class="row">
    <label class="col-4" i18n="The prefix inside the personal details block for the country of the user@@countryNamePersonalDetailPrefix">Country:</label>
    <div class="col-8 col-value">{{ user.paramValues.country }}</div>
  </div>
  <div class="row">
    <label class="col-4" i18n="The prefix inside the personal details block for the city of the user@@cityNamePersonalDetailPrefix">City:</label>
    <div class="col-8 col-value">{{ user.paramValues.city }}</div>
  </div>
  <div class="row">
    <label class="col-4" i18n="The prefix inside the personal details block for the zip code of the user@@zipCodePersonalDetailPrefix">Zip Code:</label>
    <div class="col-8 col-value">{{ user.paramValues.zipCode }}</div>
  </div>
</div>
<div class="edit-account" *ngIf="editForm">
  <form [formGroup]="editForm">
    <div class="row">
      <label class="col-4" i18n="The prefix inside the personal details block for the first name of the user@@firstNamePersonalDetailPrefix">First Name:</label>
      <div class="col-8 col-value"><input type="text" class="form-control" formControlName="firstName" [readonly]="isFormDisabled"></div>
    </div>
    <div class="row">
      <label class="col-4" i18n="The prefix inside the personal details block for the last name of the user@@lastNamePersonalDetailPrefix">Last Name:</label>
      <div class="col-8 col-value"><input type="text" class="form-control" formControlName="lastName" [readonly]="isFormDisabled"></div>
    </div>
    <div class="row">
      <label class="col-4" i18n="The prefix inside the personal details block for the company of the user@@companyNamePersonalDetailPrefix">Company:</label>
      <div class="col-8 col-value"><input type="text" class="form-control" formControlName="company" [readonly]="isFormDisabled"></div>
    </div>
    <div class="row">
      <label class="col-4" i18n="The prefix inside the personal details block for both the country (to retrieve the country phone prefix) and the phone of the user@@countryPhonePersonalDetailPrefix">Country / Phone:</label>
      <div class="col-8 col-double-group">
        <div class="country-and-phone">
          <select
            formControlName="country"
            class="form-control"
            i18n-placeholder="confirm country placeholder|The placeholder that is visible at an country input before a value is selected@@countryPlaceholder"
            placeholder="Country"
            autocomplete="country"
            required
            [style.color]="country.value === '' ? '#777' : '#495057'"
          >
            <option
              disabled
              value=""
              selected
              i18n="confirm country placeholder|The placeholder that is visible at an country input before a value is selected to it@@countryPlaceholder"
            >Country</option>
            <option *ngFor="let country of countries; index as i" [value]="country.name">{{ country.name + ' ' + country.codeNumber }}</option>
          </select>
          <input
            formControlName="phone"
            type="text"
            class="form-control"
            i18n-placeholder="confirm telephone placeholder|The placeholder that is visible at an telephone input before a content is written to it@@telephonePlaceholder"
            placeholder="Phone Number"
            autocomplete="phone"
            required
          />
        </div>
      </div>
    </div>
    <div class="row">
      <label class="col-4" i18n="The prefix inside the personal details block for the city of the user@@cityNamePersonalDetailPrefix">City:</label>
      <div class="col-8 col-value"><input type="text" class="form-control" formControlName="city" [readonly]="isFormDisabled"></div>
    </div>
    <div class="row">
      <label class="col-4" i18n="The prefix inside the personal details block for the zip code of the user@@zipCodePersonalDetailPrefix">Zip Code:</label>
      <div class="col-8 col-value"><input type="text" class="form-control" formControlName="zipCode" [readonly]="isFormDisabled"></div>
    </div>
    <div class="row" *ngIf="formErrors">
      <div class="offset-1 col-10 alert alert-danger" *ngFor="let error of formErrors">{{ error }}</div>
    </div>
    <div class="row">
      <div class="col-12 actions" style="padding-right: 22px;">
        <button
          role="button"
          type="button"
          class="btn btn-danger"
          [disabled]="isFormLoading"
          (click)="onCancelClick()"
          i18n="generic button label to cancel or close|A generic button label to close or cancel a form without saving nor submitting the changes@@genericCloseButton"
        >Close</button>
        <button
          role="button"
          type="button"
          class="btn btn-primary"
          [disabled]="isFormLoading"
          (click)="onSubmitClick()"
          i18n="generic button label to save or submit|A generic button label to save or submit a form, sending the changes to the server@@genericSaveButton"
        >Save</button>
      </div>
    </div>
  </form>
</div>
